import { SearchApi } from 'legacy/lut/classes/services/api/SearchApi'

import { Region } from 'clickNgo/configs/geo'

import { IPartnerSearchRequest } from '../models/partner/partnerSearchRequest'
import { ISearchParametersBase } from '../models/search'

import { getPartnerData } from './getPartnerData'

interface IMapFiltersToPartnerSearchParameters extends Omit<ISearchParametersBase, 'user'> {
  region: Region
}

export const mapFiltersToPartnerSearchParameters = ({
  filters,
  region,
  countries,
}: IMapFiltersToPartnerSearchParameters): IPartnerSearchRequest => {
  return {
    page: filters.pagination.partnersPage,
    pageSize: 10,
    condition: {
      input: filters.search,
      market: filters.common.market !== SearchApi.IN_REGION ? filters.common.market : undefined,
      region,
      common: {
        isMine: filters.common.isMine,
        isDis: filters.common.isDistributors,
        isBPOnly: filters.common.isBusinessPartner,
        isAmplifyRetail: filters.common.isRetailAmplify,
        isRetail: filters.common.isRetail,
        isAmplifyCommercial: filters.common.isCommercialAmplify,
        isCommercial: filters.common.isCommercial,
      },
      partner: getPartnerData({
        partnerFilters: filters.partner,
        isBranchVisible: filters.common.isBranchVisible,
        countries,
        type: 'partners',
      }),
    },
  }
}
